import { IconSend } from '@tabler/icons-react-native';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Button } from 'app/design/primitives/button';
import { GUARDIAN_BLUE } from 'app/shopify/components/feedback/GuardianBadge';
import { useTranslation } from 'react-i18next';
import { localeAwareFormatDistance } from 'app/lib/date';
import { useNavigation } from 'app/hooks/navigation';
import { navigateToChat } from 'app/screens/chat/navigator-helper';
import type { Listing } from 'app/types/listing';
import { useUser } from 'app/network/user';
import MemberCard from 'app/screens/groups/member-card';
import { Pressable } from 'react-native';
import { navigateToUserProfile } from 'app/screens/billboard/navigator-helper';

export function GuardianBanner({ listing }: { listing: Listing }) {
  const { t } = useTranslation('guardian');
  const { data: user } = useUser();
  if (!listing.guardianId || listing.userId !== user?.id) return null;
  return (
    <Row
      justifyContent="center"
      alignItems="center"
      gap="spacing.general.x1"
      padding="spacing.general.x3"
      style={{ backgroundColor: GUARDIAN_BLUE }}
    >
      <IconSend size={16} color="white" />
      <Text color="white" fontSize={12} flexShrink={1} textAlign="center">
        {t('banner', {
          ago: listing.guardianSince ? localeAwareFormatDistance(new Date(), new Date(listing.guardianSince)) : '',
        })}
      </Text>
    </Row>
  );
}

export function GuardianOwnerSection({ listing }: { listing: Listing }) {
  const { t } = useTranslation('guardian');
  const { data: user } = useUser();
  const navigation = useNavigation();
  if (!user?.id || !listing.guardianId) return null;
  if (listing.userId === user.id && (listing.guardian || listing.guardianChannelId))
    return (
      <Column padding="spacing.general.x4" gap="spacing.general.x3">
        {listing.guardian ? <MemberCard {...listing.guardian} /> : null}
        {listing.guardianChannelId ? (
          <Button variant="primary" onPress={() => navigateToChat(navigation, listing.guardianChannelId!)}>
            {t('contact')}
          </Button>
        ) : null}
      </Column>
    );
  if (listing.guardianId !== user.id) return null;
  return (
    <Column padding="spacing.general.x4" gap="spacing.general.x3">
      <Text fontWeight="600">{t('owner')}</Text>
      <Pressable accessibilityRole="button" onPress={() => navigateToUserProfile(navigation, listing.userId)}>
        <MemberCard {...listing.user} />
      </Pressable>
      <Button
        variant="secondary"
        onPress={() => navigation.navigate('edit-listing', { id: listing.id }, { pop: true })}
      >
        {t('manageOffer')}
      </Button>
    </Column>
  );
}
